import React from 'react';

const Navigation = ({ next, prev, textNext, textPrev }) => {
    return (
        <div className={`navigation`}>
            <div><a href={prev}><span>{'<'}</span> {textPrev}</a></div>
            <div><a href={next}>{textNext} <span>{'>'}</span></a></div>
        </div>
    );
};

export default Navigation;